// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"31":"50931e18","50":"9b12e3a6","698":"8be39eaf"}[chunkId] + ".js";
};